import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.SeekAndFind;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "SeekAndFind.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "SeekAndFind.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "SeekAndFind.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/SeekAndFindGame/scenes/IntroductionScene.ts